import React, { Fragment, useEffect, useState } from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Background from '../Background/Background';
import OverlapCard from '../Cards/OverlapCard';
import searchingBear from 'Assets/img/svg/searchingBear.svg';
import searchingBearMobile from 'Assets/img/svg/searchingBearMobile.svg';
import { useStyles } from './option.style';
import Questioner from './Questioner';
import { BackButton, CommonButton, NextButton } from 'Components/Reusable/Buttons/Buttons';
import { useDispatch, useSelector } from 'react-redux';
import { getQuestions, getToy, postQuestionarre } from 'ReduxStore/toys/Action';
import { useParams, useHistory } from 'react-router-dom';
import { changeIdentities, setActivitiesImage } from 'Helpers';
import Grid from '@material-ui/core/Grid';
import backButton from 'Assets/img/svg/buttons/back.svg';
import { RootState } from 'ReduxStore';
import optionImage from 'Assets/img/svg/generate.svg'
interface RouteParams {
	id: string;
}

const questions = [
	{
		id: 1,
		question: `What was {NAME} experience with this month’s toy?`,
		options: [
			{
				id: 1,
				letter: 'A',
				info: 'Needs more time',
			},
			{
				id: 2,
				letter: 'B',
				info: 'He got on averagely with it',
			},
			{
				id: 3,
				letter: 'C',
				info: 'Way too easy',
			}
		],
	},
	{
		id: 2,
		question: `1 What was {NAME} experience with this month’s toy?`,
		options: [
			{
				id: 1,
				letter: 'A',
				info: 'Needs more time',
			},
			{
				id: 2,
				letter: 'B',
				info: 'He got on averagely with it',
			},
			{
				id: 3,
				letter: 'C',
				info: 'Way too easy',
			}
		],
	},
	{
		id: 3,
		question: `2 What was {NAME} experience with this month’s toy?`,
		options: [
			{
				id: 1,
				letter: 'A',
				info: 'Needs more time',
			},
			{
				id: 2,
				letter: 'B',
				info: 'He got on averagely with it',
			},
			{
				id: 3,
				letter: 'C',
				info: 'Way too easy',
			}
			
		],
	},
];

const options = [
	{
		id: 1,
		letter: 'A',
		info: 'Needs more time',
	},
	{
		id: 2,
		letter: 'B',
		info: 'Ready for next ',
	},
	{
		id: 3,
		letter: 'C',
		info: 'Way too easy',
	}
	
];

const Options = () => {
	const childId = localStorage.getItem('currentChildId');
	const Question = useSelector((state: RootState) => state.toys['toyQuestionnaire']);
	const toys = useSelector((state: RootState) => state.toys.toy);
	const matches = useMediaQuery('(max-width:425px)');
	const classes = useStyles();
	const dispatch = useDispatch();
	const params = useParams<RouteParams>();
	const history = useHistory();
	const [isActive, setActive] = useState(false);
	const [data,setData] = useState<any>([]);
	const [count,setCount] = useState<any>(0)
	const [activeBudge, setActiveBudge] = useState<any>(0);
	const [selected, setSelected] = useState<any>(0);
	const [lastQuestion, setLastQuestion] = useState(false);
	const [currentQuestion, setCurrentQuestion] = useState(0);
	const [firstQue, setFirstQue] = useState(0);
	const [firstAns, setFirstAns] = useState<any>(0);
	const [secondQue, setSecondQue] = useState(0);
	const [secondAns, setSecondAns] = useState<any>(0);
	const [thirdQue, setThirdQue] = useState(0);
	const [thirddAns, setThirdAns] = useState<any>(0);
	const [thirdForuth, setForuthQue] = useState(0);
	const [ForuthAns, setForuthAns] = useState<any>(0);
	const [message, setMessage] = useState<string>('')


	useEffect(() => {
		dispatch(getToy())
		dispatch(getQuestions());
	}, []);

	useEffect(() => {
		if(Question && Question.length > 0){
			const questions = Question.map((que:any) => {
				return {...que,options}
			})
			setData([...questions])
		} 
	}, [Question]);


	const handleSelected = (e: any, value?: number) => {
		if (!value){
			setMessage("Kindly pick a choice")
			return 
		}
		setActive(true);
		setSelected(value);
		setActiveBudge(value);
		if (currentQuestion === 0) {
			setFirstAns(value);
			setFirstQue(1);
		} else if (currentQuestion === 1) {
			setSecondAns(value);
			setSecondQue(2);
		} else if (currentQuestion == 2) {
			setThirdAns(value);
			setThirdQue(3);
			// setLastQuestion(true);
		}else if (currentQuestion == 3) {
			setForuthAns(value);
			setForuthQue(4);
			setLastQuestion(true);
		}
	};
	const toyId = params.id;
	const handleOnClick = () => {
		
		if (currentQuestion < data.length - 1) {
			setCurrentQuestion(currentQuestion + 1);
			setActive(false);
		} else {
			setLastQuestion(true);
		}
		if (lastQuestion) {
			dispatch(postQuestionarre(firstQue, secondQue, firstAns, secondAns, thirddAns,ForuthAns ,params.id));
			history.push(`/generate-toy/${childId}`)
		}
	};

	const childName = localStorage.getItem('currentChild');
	return (
		<Fragment>
			<Background backgroundColor="#86E3CE" height={matches ? '100vh' : '100vh'} overflow="auto"  position='sticky'>
				<div className={matches ? '' : 'px-3 py-2'}>
					<BackButton image={backButton} />
				</div>
				<OverlapCard
					image={matches ? searchingBearMobile : searchingBear}
					common={{
						margin: '-5rem auto 2rem',
						width: '80%',
						borderBottomLeftRadius: '0',
						borderBottomRightRadius: '0',
					}}
					options
				>
					<h5 className="text-center py-4">{toys?.toy.name}</h5>
					<div style={{ display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center'}}>
					<img src={toys?.toy.imageName && setActivitiesImage(toys?.toy.imageName)} className={classes.topImage} alt="an svg"/>
					</div>
					
					<h6 className="text-center py-3 px-2">
						{data[currentQuestion] && changeIdentities(data[currentQuestion]?.question, childName)}
					</h6>
					<ul className={`${classes.listItems} mb-5`}>
						{data[currentQuestion]?.options?.map((option:any) => (
							<li
								key={option.id}
								onClick={e => handleSelected(e, option.id)}
								className={`${
									isActive && selected === option.id ? classes.activeBg : classes.inactiveBg
								} d-flex flex-nowrap mx-auto justify-content-around align-items-center py-2`}
							>
								<Grid item xs={1}>
									<h5
										className={
											isActive && activeBudge === option.id ? classes.activeBudge : classes.inactiveBudge
										}
									>
										{option.letter}
									</h5>
								</Grid>
								<Grid item xs={6}>
									<h5 className={classes.text}>{option.info}</h5>
								</Grid>
							</li>
						))}
					</ul>
				</OverlapCard>
				<div className="d-flex flex-nowrap mx-auto justify-content-around align-items-center">
					<CommonButton
					disabled={selected ? false : true}
						onClick={handleOnClick}
						command={lastQuestion ? 'SUBMIT' : 'NEXT'}
						common={{
							width: '120px',
							height: '48px',
							fontSize: '16px',
							background: 'white',
							radius: '20px',
							margin: '2rem auto',
							color: '#78393D',
						}}
					/>
				</div>
			</Background>
		</Fragment>
	);
};

export default Options;
